import scrollAnimation from "../../plugins/scrollAddClass.js";
scrollAnimation.init();

// scrollAnimation.init({
//   target: '.js-hoge',
//   addClassName: "is-hoge",
//   triggerHook: "onCenter",
//   offset: 100,
//   leave: false
// });